import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import type { DeferredDownPayment } from '@makemydeal/dr-platform-types';

export const useDeferredDownPaymentSlideOut = () => {
    const [slideOut, setSlideOut] = useState(false);
    const defermentValuesFromSelector = useSelector(offerReduxSelectors.getDeferredDownPayment);
    const [deferredDownPayment, setDeferredDownPayment] = useState<DeferredDownPayment>({
        amount: defermentValuesFromSelector?.amount || 0,
        paymentDate: defermentValuesFromSelector?.paymentDate || ''
    });

    // Update local state when Redux state changes (e.g., after init/fetch from Deal API)
    useEffect(() => {
        if (defermentValuesFromSelector) {
            setDeferredDownPayment({
                amount: defermentValuesFromSelector.amount || 0,
                paymentDate: defermentValuesFromSelector.paymentDate || ''
            });
        }
    }, [defermentValuesFromSelector]);

    const toggleSlideOut = useCallback(() => {
        setSlideOut(!slideOut);
    }, [slideOut]);

    const handleClear = useCallback((values: DeferredDownPayment) => {
        setDeferredDownPayment(values);
    }, []);

    const handleCancel = useCallback(() => {
        setSlideOut(false);
    }, []);

    const handleApply = useCallback((values: DeferredDownPayment) => {
        setDeferredDownPayment(values);
        setSlideOut(false);
    }, []);

    return {
        isSlideOutOpen: slideOut,
        toggleSlideOut,
        slideOutProps: {
            show: slideOut,
            onCancel: handleCancel,
            onApply: handleApply,
            onClear: handleClear,
            initialValues: deferredDownPayment
        }
    };
};
